import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getUsers } from '../../../actions/usersActions'
import { getCardsauxByOperator, removeCardaux } from '../../../actions/cardsauxActions'
import Select from "react-select"
import moment from 'moment-timezone'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { CustomDataTable } from "../../../components/design/Datatables/CustomDataTable"

export default function Cards() { 
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {cardsaux} = useSelector((state) => state.cardsaux)
    const {users} = useSelector((state) => state.users)
    const [operatorOptions, setOperatorOptions] = useState({options: [], selected: null})

    useEffect(()=>{
        dispatch(getUsers())
    }, [dispatch])

    const handleSelectOperatorChange = (selectedOption) => {
        if (selectedOption !== null) {
            let operatorsSelected
            let userOperators = users?.filter(user => user.rol === 'Operario')
            userOperators?.forEach(operator => {
                if(selectedOption.value === operator._id){
                    operatorsSelected = {value: operator._id, label: `${operator.lastname}, ${operator.firstname}`}
                }
            })
            setOperatorOptions({...operatorOptions, selected: operatorsSelected})
            dispatch(getCardsauxByOperator(selectedOption.value))
        } else {
            setOperatorOptions({selected: null})
        }
    }

    useEffect(() => {
        if(users !== null){
            let userOperators = users?.filter(user => user.rol === 'Operario')
            let operatorsAvailabe = []
            let operatorsSelected = null
            userOperators?.forEach(operator => {
                let object = {value: operator._id, label: `${operator.lastname}, ${operator.firstname}`}
                operatorsAvailabe.push(object)
            })
            setOperatorOptions({options: operatorsAvailabe, selected: operatorsSelected})
        }
    }, [users])

    const deleteCardaux = (idCardaux) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeCardaux(idCardaux))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    const goBack = () => {
        navigate('/manager/dashboard')
    }

    // Datatables
    const columns = [
        {
            name: t('cardaux.dateinout'),
            cell: card =>
                <div>
                    {moment(new Date(card.in)).format('DD/MM/YYYY')}<br/>{moment(new Date(card.in)).format('HH:mm:ss')} - {moment(new Date(card.out)).format('HH:mm:ss')}
                </div>,
            selector: (card) => card._id,
            sortable: true,
        },{
            name: t('cardaux.labor'),
            cell: card =>
                <div>
                    {card.labor.name}
                </div>,
            selector: (card) => card._id,
            sortable: true,
        },{
            name: t('cardaux.origen'),
            cell: card =>
                <div>
                    {card.plot.farm.name}<br/>{card.plot.name}<br/>{card.crop.name}
                </div>,
            selector: (card) => card._id,
            sortable: true,
        },{
            name: t('cardaux.state'),
            cell: card =>
                <div>
                    {t('manager.'+card.state)}
                </div>,
            selector: (card) => card._id,
            sortable: true,
        },{
            name: '',
            cell: card =>
                    <Button variant="outline-danger p-1" onClick={() => deleteCardaux(card._id)} hidden={card.state === 'pending'?false:true}>
                        {t('resume.remove')}
                    </Button>
        }
    ]

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('manager.managecards')}</h1>
                    <Form.Label className="form-label">{t('manager.selectaction')}</Form.Label>
                    <br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Form.Label>{t('manager.operator')}</Form.Label>
                            <Select
                                onChange={handleSelectOperatorChange}
                                name="operator"
                                placeholder={t('manager.selectoperator')}
                                options={operatorOptions?.options}
                                value={operatorOptions?.selected}
                            />
                        </Col>
                    </Row>
                </Row>
                <Row className="text-center custom-card-body justify-content-center">
                    {cardsaux 
                        ?
                            <CustomDataTable columns={columns} data={cardsaux} />
                        :
                            <></>
                    }
                </Row>
            </Container>
        </>
    )
}


  
                
